const black = "rgb(77,77,77)";
const white = "#fafbfd";
const lightgray = "#cdcdcd";
const baykaBlue = "#01a0e4";
const darkGray = "#222222";

const theme = {
  font: {
    size: {
      xs: "14px",
      sm: "16px",
      md: "18px",
      lg: "25px",
      xlg: "40px",
    },
  },
  color: {
    font: {
      primary: black,
      secondary: white,
      thirdary: "rgb(77,77,77)",
      hint: lightgray,
      bayka: baykaBlue,
    },
    background: {
      primary: white,
      secondary: black,
      bayka: baykaBlue,
      fourth: "rgb(77,77,77)",
      fifth: "rgb(242,242,242)",
      red: "rgb(208,47,38)",
      footer: darkGray,
    },
    border: {
      primary: black,
      secondary: white,
      bayka: baykaBlue,
    },
  },
  breakpoint: {
    sm: "768px",
    md: "992px",
    lg: "1200px",
  },
  border: {
    radius: "5px",
  },
  header: {
    background: white,
    font: black,
    height: "60px",
  },
  shadow: "2px 2px 16px -1px rgba(0,0,0,0.48)",
};

const adjustedComponentStyling = {
  accordion: {
    accordion: ``,
    flex: ``,
    item: {
      item: ``,
      header: ``,
      text: ``,
      openicon: ``,
      body: ``,
    },
  },
  button: {
    button: ``,
    anchor: ``,
  },
  checkbox: {
    checkbox: ``,
    flex: ``,
    checkedicon: ``,
    label: ``,
    styledcheckbox: ``,
  },
  container: {
    container: ``,
  },
  draganddrop: {
    draganddrop: `height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background-color: white;
      border-radius: 0px;
    `,
    title: `text-transform: uppercase;
      color: ${theme.color.font.primary};
      font-size: ${theme.font.size.lg};
      font-family: bold;
    `,
    hint: `
      font-style: unset;
    `,
    filelist: ``,
    filename: ``,
  },
  dropdown: {
    dropdown: ``,
    select: ``,
    option: ``,
    label: ``,
  },
  form: {
    form: ``,
  },
  headline: {
    headline: ``,
  },
  hero: {
    hero: ``,
  },
  input: {
    input: `
      background-color: white;
      border-radius: 0px;
      border: none;
      border-bottom: thin solid ${theme.color.border.bayka};
      &:focus {
        border: thin solid ${theme.color.border.bayka};
      }
    `,
    wrapper: ``,
    label: ``,
  },
  link: {
    link: ``,
  },
  modal: {
    modal: ``,
    background: ``,
    core: ``,
    header: ``,
    title: ``,
    close: ``,
    content: ``,
    footer: ``,
  },
  progressbar: {
    progressbar: ``,
    progress: ``,
    label: ``,
  },
  textarea: {
    textarea: `
    background-color: white;
    border: none;
    border-bottom: thin solid ${theme.color.border.bayka};
    &:focus {
      border: thin solid ${theme.color.border.bayka};
    }
    `,
    wrapper: ``,
    label: ``,
  },
  datepicker: {
    wrapper: ``,
    label: ``,
  },
};

const buildTheme = { ...theme, components: adjustedComponentStyling };

export default buildTheme;
